import React, { FC } from 'react';
import { BatchWithColor, HoverState, ERPState, SelectedItem } from '@v2/context/ProductionBatch/types';
import { getLinkingModalConfig, ncFileStatuses, Popup, withERP } from '@helpers';
import NCFileType from '@components/common/NCFileType';
import { fullWidth, scale } from '@components/frame';
import ProductionInformation from '@components/productionInformation';
import { shouldHideInfoOnHover, parseBatchNumber } from '@v2/context/ProductionBatch/tile/helpers';
import { Text, TouchableOpacity, View } from 'react-native';
import { font } from '@styles/fonts';
import LinkIcon from '@v2/context/ProductionBatch/linkIcon';
import i18n from 'i18n-js';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

export interface BatchNumberWithStatusProps extends BatchWithColor, HoverState, ERPState, SelectedItem {}

const BatchNumberWithStatus: FC<BatchNumberWithStatusProps> = ({
  batch,
  C,
  hovered,
  isWithERP,
  selectedItem,
}: BatchWithColor & HoverState & ERPState & SelectedItem) => {
  const [firstPart, secondPart] = parseBatchNumber(batch.batchNumber);

  const hoveredButtonConfig = {
    [ncFileStatuses.Unknown]: {
      text: 'Select NC File Type',
      action: () =>
        Popup({
          Component: (p: any) => (
            <NCFileType
              {...{ ...p, selectedItem, productionBatchId: batch.productionBatchId, ncFileId: batch?.ncFileId, ncFileName: batch?.ncFileName }}
            />
          ),
          ...getLinkingModalConfig(scale, fullWidth),
        }),
    },
    [ncFileStatuses.Linked]: {
      text: 'Link',
      action: () =>
        Popup({
          Component: (p: any) => (
            <ProductionInformation
              {...{
                ...p,
                selectedItem,
                productionBatchId: batch?.productionBatchId,
                selectedNCFileId: batch?.ncFileId,
              }}
            />
          ),
          ...getLinkingModalConfig(scale, fullWidth),
        }),
    },
  };

  const hoveredButtonState = hoveredButtonConfig[batch.ncFileStatus];
  const hideInfoOnHover = shouldHideInfoOnHover({ isWithERP, links: batch.links, ncFileStatus: batch.ncFileStatus });

  return (
    <View style={{ flexDirection: 'row', gap: scale(6), alignItems: 'center' }}>
      {batch.batchNumber && (
        <Text style={[font.Headline, { color: C('Label/Light/Tertiary') }]}>
          {firstPart}
          {'-'}
          <Text style={[font.Headline, { color: C('Label/Light/Primary') }]}>{secondPart}</Text>
        </Text>
      )}
      {!(hovered && hideInfoOnHover) ? (
        <LinkIcon isWithERP={withERP(isWithERP)} linkStatus={batch.linkStatus} ncFileStatus={batch.ncFileStatus} />
      ) : (
        <TouchableOpacity
          testID={TEST_IDS.searchScreen.productionBatches.batchHoverButton}
          style={{
            height: scale(25),
            borderRadius: scale(13),
            backgroundColor: C('Button/Light/Primary'),
            paddingHorizontal: scale(14),
            justifyContent: 'center',
            position: 'relative',
          }}
          onPress={hoveredButtonState.action}
        >
          <Text style={[font['Button 3'], { color: C('Label/Light/Selected') }]}>{i18n.t(hoveredButtonState.text)}</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default BatchNumberWithStatus;
